var _path, _path2, _rect, _path3, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.768 58.523c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#62748A",
    d: "m88.536 23.368 6.869 7.487-3.744 3.434-6.868-7.487z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.847,
    y: 16.191,
    width: 20.319,
    height: 5.08,
    rx: 2.54,
    transform: "rotate(47.467 88.847 16.19)",
    fill: "#A9BBC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#62748A",
    d: "m42.435 19.023-8.146 6.072 3.036 4.073 8.146-6.072z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.319,
    height: 5.08,
    rx: 2.54,
    transform: "scale(-1 1) rotate(36.701 -39.696 -59.572)",
    fill: "#A9BBC9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.814,
    cy: 52.006,
    r: 33.567,
    transform: "rotate(5.383 62.814 52.006)",
    fill: "url(#a)",
    stroke: "#A9BBC9",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.931,
    y: 24.142,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(5.383 64.93 24.142)",
    fill: "#F17D83"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.166,
    y: 74.716,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(5.383 60.166 74.716)",
    fill: "#A9BBC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.232,
    y: 53.663,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(95.383 91.232 53.663)",
    fill: "#A9BBC9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.657,
    y: 48.897,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(95.383 40.657 48.897)",
    fill: "#A9BBC9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.919,
    y: 72.928,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(140.383 81.919 72.928)",
    fill: "#A9BBC9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.527,
    y: 33.796,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(140.383 49.527 33.796)",
    fill: "#A9BBC9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42.447,
    y: 70.652,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(-129.617 42.447 70.652)",
    fill: "#A9BBC9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81.577,
    y: 38.26,
    width: 2.032,
    height: 5.08,
    rx: 1.016,
    transform: "rotate(-129.617 81.577 38.26)",
    fill: "#A9BBC9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 63.369,
    y: 51.547,
    width: 2.032,
    height: 22.137,
    rx: 1.016,
    transform: "rotate(5.383 63.37 51.547)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 64.973,
    y: 50.439,
    width: 2.944,
    height: 15.704,
    rx: 1.472,
    transform: "rotate(144.547 64.973 50.439)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.38,
    cy: 51.643,
    r: 4.064,
    transform: "rotate(5.383 64.38 51.643)",
    fill: "#D0DCE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 26.747,
    y1: 20.748,
    x2: 98.881,
    y2: 91.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62748A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.2db192da498a4f7ea7109fedaa57cdc6.svg";
export { ForwardRef as ReactComponent };